import { render, staticRenderFns } from "./OverDueMilestoneWidget.vue?vue&type=template&id=78a37955&"
import script from "./OverDueMilestoneWidget.vue?vue&type=script&lang=js&"
export * from "./OverDueMilestoneWidget.vue?vue&type=script&lang=js&"
import style0 from "./OverDueMilestoneWidget.vue?vue&type=style&index=0&id=78a37955&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports